import http from '~/http/services/pos';

type UserRestaurantRolesResponse = {
  userRestaurantRoles: {
    userRestaurantRoleId: string;
    user: {
      userId: string;
      username: string;
    };
    restaurantId: string;
    roles: [
      {
        roleId: string;
        roleName: string;
      }
    ];
  }[];
};

const fetchUserRestaurantRoles = () => {
  return http.get<UserRestaurantRolesResponse>('/api/v2/user-restaurant-roles');
};

const confirmAuthorize = (body: {
  username: string;
  pin: string;
  permissionName: string;
  entityId: string;
}) => {
  return http.post<{ isAuthorized: boolean; actionToken: string }>(
    '/api/v2/actions/authorize',
    body
  );
};

export default {
  fetchUserRestaurantRoles,
  confirmAuthorize,
};
